<template>
    <b-navbar ref="navwrapper" fixed="top" toggleable="lg" type="dark">
      <b-container fluid class="py-1 px-5">
        <b-navbar-brand @click.prevent="top">
          <impact-logo :height="logoheight"></impact-logo>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse">
          <template v-slot:default="{ expanded }">
            <b-icon v-if="expanded" icon="chevron-bar-up"></b-icon>
            <b-icon v-else icon="chevron-bar-down"></b-icon>
          </template>
        </b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item v-for="page in pages" @click.prevent="jumpTo(page.section)" :key="page.order"><b-icon icon="hexagon-fill" variant="primary" scale="1.20" class="mr-2"></b-icon> <span class="navtext">{{page.display}}</span></b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
</template>

<script>
import ImpactLogo from "@/components/elements/ImpactLogo"

export default {
  name: 'nav-bar',
  components: {ImpactLogo},
  inject: ["jumpTo", "top"],
  data() {
    return {
      logoheight: "55px",
      pages: [
        {
          order: 1,
          section: "services",
          display: "What we do"
        },
        {
          order: 2,
          section: "about",
          display: "Who we are"
        },
        {
          order: 3,
          section: "contact",
          display: "Get in touch"
        }
      ]
    }
  },
  computed: {
    navHeight: {
      get: function () {
        return this.height;
      },
      set: function (value) {
        this.height = value;
      }
    },
  }
}
</script>

<style lang="scss">
@import '@/styles/custom';

.navbar {
  background-color: rgba(0,0,0,0.9);
  transition: all 0.5s;

  .navbar-brand {
    svg {
      transition: all .5s;
    }
  }

  .nav-item {
    transition: all .25s;
    .navtext {
      transition: all .25s;
    }
  }

  &.condense {
    background-color: rgba(0,0,0,0.8);

    //.navtext {
    //  visibility: hidden;
    //  width: 0;
    //  font-size: 0;
    //}
  }
}
</style>